import ufeApi from 'services/api/ufeApi';
import localeUtils from 'utils/LanguageLocale';
import urlUtils from 'utils/Url';
import sysUtils from 'utils/ShopYourStore';

// https://confluence.sephora.com/wiki/display/ILLUMINATE/GET+ROPIS+Specific+Product+Details

function getRopisSpecificProductDetails(profileId = 'current', productId, skuId = null, source = 'other') {
    const apiVersion = '/api/v3';

    let url = `${apiVersion}/users/profiles/${profileId}/ropisproduct/${productId}`;
    const queryStringParams = { ...sysUtils.getMultiStoreFilteringQueryParams() };

    if (skuId !== null) {
        queryStringParams.preferedSku = skuId;
        queryStringParams.countryCode = localeUtils.getCurrentCountry();
        queryStringParams.loc = localeUtils.getCurrentLanguageCountryCode().replace('_', '-');
    }

    const queryString = urlUtils.makeQueryString(queryStringParams);

    if (queryString) {
        url += '?' + queryString;
    }

    const options = {
        method: 'GET',
        headers: { 'x-sephora-page-source': source }
    };

    return ufeApi.makeRequest(url, options).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getRopisSpecificProductDetails;
